/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Page } from '../../models/page';

export interface ApiMasterPageGetActiveGet$Params {
}

export function apiMasterPageGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterPageGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Page>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPageGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Page>>;
    })
  );
}

apiMasterPageGetActiveGet.PATH = '/api/Master/Page/GetActive';
